module.exports = __webpack_public_path__ + "img/taptap.befec338.svg";